import { number } from 'prop-types';
import React from 'react';

import { useFormatPrice } from '~hooks/useFormatPrice';
import { formatQuantity } from '~utils/number';

const QuantityAndPrice = ({ quantity, price }) => {
  const formatPrice = useFormatPrice();
  return (
    <div>
      <span className="m-right-2">{formatQuantity(quantity)}</span>
      <span className="font-size-14 bold">{`${formatPrice(price || 0)}`}</span>
    </div>
  );
};

QuantityAndPrice.propTypes = {
  price: number,
  quantity: number
};

export default QuantityAndPrice;
